import { freeze } from '@reduxjs/toolkit';
import {
  ILlmSummarizeSectionsInput,
  LlmSubjectKind,
} from '../../../utils/apollo/graphqlSchema';
import { ILlmState, ILlmSubjectState, LlmSubjectsCache } from './types';
import { assertNotNil } from '../../../utils/types';
import { UnreachableCaseError } from 'ts-essentials';

export const defaultLlmState = freeze<ILlmState>({
  explainAnalyses: {},
  explainDashboards: {},
});

export const defaultLlmSections = freeze<ILlmSummarizeSectionsInput>({
  executiveSummary: true,
  keyInsights: true,
  recommendations: true,
  summaryStatistics: true,
});

export const defaultLlmSubjectState = freeze<ILlmSubjectState>({
  llmSummary: null,
  loading: false,
  sections: defaultLlmSections,
  cachedRawData: null,
});

export const getLlmCache = (
  draft: ILlmState,
  subjectKind: LlmSubjectKind,
): LlmSubjectsCache => {
  let map: LlmSubjectsCache | null = null;
  switch (subjectKind) {
    case LlmSubjectKind.Analysis:
      map = draft.explainAnalyses;
      break;
    case LlmSubjectKind.Dashboard:
      map = draft.explainDashboards;
      break;
    default:
      throw new UnreachableCaseError(subjectKind);
  }
  assertNotNil(map);
  return map;
};
